module.exports = __webpack_public_path__ + "img/open-cage-rate-right-bottom-icon.155646cc.png";